import { render, staticRenderFns } from "./page-job-candidate-list.vue?vue&type=template&id=18fe7a9b&"
import script from "./page-job-candidate-list.vue?vue&type=script&lang=js&"
export * from "./page-job-candidate-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports